'use strict';

const nl2br = function () {
  return function (input) {
    return angular.isString(input) ? input.replace(/\n/g, '<br>'): input;
  };
};

export default nl2br;



// WEBPACK FOOTER //
// ./app/src/filters/nl2br.js